import { useEffect, useState } from 'react';
import { useGetShippingLines } from 'api/counterparties';
import {
  GetShippingLineParams,
  ShippingLine,
} from 'api/counterparties/counterparties.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function ShipownerAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getShippingLines } = useGetShippingLines();
  const [options, setOptions] = useState<ShippingLine[]>([]);
  const [shippingLinesParams, setShippingLinesParams] =
    useState<GetShippingLineParams>({
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
    });

  useEffect(() => {
    getShippingLines(shippingLinesParams);
  }, [getShippingLines, shippingLinesParams]);

  useEffect(() => {
    if (data?.length) {
      const fetchedOptions = data.map((shippingLine) => ({
        businessFunctions: shippingLine.businessFunctions,
        id: shippingLine.businessFunctions[0].id,
        code: shippingLine.code,
        enabled: shippingLine.businessFunctions[0].enabled,
      }));
      const filteredOptions = fetchedOptions.filter(
        (activity) => activity.enabled,
      );
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code || o.counterpartyShortName}
      handleSearchChange={handleChange(setOptions, setShippingLinesParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setShippingLinesParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setShippingLinesParams,
        formProps.field.onBlur,
      )}
    />
  );
}
